module.exports = __webpack_public_path__ + "static/media/ring_to_friend1.fe6e9613.png";